// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"bbc8e54c","990":"7a7feafb"}[chunkId] + ".chunk.css";
};